<template>
  <v-data-table
    :expanded="tableMixin_expandedRows"
    :footer-props="{
      'items-per-page-options': [pagination.per_page],
    }"
    :items-per-page="pagination.per_page"
    :headers="tableMixin_displayedHeaders"
    :items="displayedItems"
    :mobile-breakpoint="0"
    :page="pagination.current_page"
    :server-items-length="pagination.total"
    :class="{ 'content-loading': loading }"
    disable-sort
    @update:page="tableMixin_changePage"
    @click:row="tableMixin_onRowClick"
  >
    <template v-slot:item.description="{ item }">
      <div class="link" @click="displayFormatedText(item)">
        {{ $t('click_here_to_view') }}
      </div>
    </template>

    <template v-slot:item.translatedStatus="{ item }">
      <v-chip
        :color="!item.is_published ? 'grey lighten-4' : 'green accent-2'"
        class="text-caption persist-opacity"
        label
        small
      >
        {{ item.translatedStatus }}
      </v-chip>
    </template>

    <template v-slot:item.actions="{ item }">
      <BaseActionMenu :actions="getRowActions(item)" :item="item" />
    </template>

    <template v-slot:expanded-item="{ item }">
      <BaseExpandedTableRow
        :colspan="tableMixin_displayedHeaders.length"
        :headers="tableMixin_hiddenHeaders"
        :item="item"
      >
        <template v-slot:item.description>
          <div :inner-html.prop="item.description | truncate(600)">
            {{ item.description }}
          </div>
        </template>
      </BaseExpandedTableRow>
    </template>
  </v-data-table>
</template>

<script>
import tableMixin from '../mixins/table-mixin';
import BaseActionMenu from './base/BaseActionMenu';
import BaseExpandedTableRow from './base/BaseExpandedTableRow';

export default {
  name: 'AwardsTable',

  components: { BaseActionMenu, BaseExpandedTableRow },

  mixins: [tableMixin],

  props: {
    items: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    disabledItemIds: {
      type: Object,
      default: () => ({}),
    },
    loading: Boolean,
  },

  computed: {
    headers() {
      return [
        {
          text: this.$t('year'),
          value: 'year',
        },
        {
          text: this.$t('status'),
          value: 'translatedStatus',
        },
        {
          text: this.$t('description'),
          value: 'description',
          hidden: 'xsOnly',
        },
        {
          value: 'actions',
          align: 'end',
        },
      ];
    },

    displayedItems() {
      if (!this.items) {
        return [];
      }
      return this.items.map((r) => ({
        ...r,
        translatedStatus: this.$t(
          `contact_status.${r.is_published ? 'published' : 'not_published'}`,
        ),
      }));
    },
  },

  methods: {
    getRowActions() {
      const actions = [
        {
          callback: (p) => this.$emit('edit', p),
          label: this.$t('edit'),
          icon: 'mdi-pencil',
        },
        {
          callback: (p) => this.$emit('delete', p),
          label: this.$t('delete'),
          icon: 'mdi-delete',
        },
      ];
      return actions;
    },

    displayFormatedText(event) {
      this.$emit('click:text', event);
    },
  },
};
</script>

<style scoped></style>
